import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { Facility } from "../../../parts/kor/business/facility";
export const FACILITY = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="business">
        <Facility />
      </div>
      <FOOTER />
    </main>
  );
};
